import React from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";
import { getHexacoWebSession } from "../../services/hexacoWebApi";

const HexacoOrderCancel: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const session = getHexacoWebSession();
  const orderId = searchParams.get("order_id") || session.orderId;
  const orderPath = orderId ? `/hexaco/order/${orderId}` : "/hexaco/purchase";

  return (
    <>
      <SEO
        title={t("hexaco.purchase.cancel.seo.title")}
        description={t("hexaco.purchase.cancel.seo.description")}
        noindex
      />

      <Box bg="gray.50" py={{ base: 10, md: 14 }}>
        <Container maxW="720px">
          <VStack
            align="stretch"
            spacing={6}
            bg="white"
            borderRadius="2xl"
            boxShadow="sm"
            border="1px solid"
            borderColor="orange.100"
            px={{ base: 5, md: 8 }}
            py={{ base: 8, md: 10 }}
            textAlign="center"
          >
            <Text fontSize="4xl">⚠️</Text>
            <Heading size="lg" color="gray.800">
              {t("hexaco.purchase.cancel.title")}
            </Heading>
            <Text color="gray.600" lineHeight="tall">
              {t("hexaco.purchase.cancel.description")}
            </Text>

            <VStack spacing={3}>
              <Button
                as={RouterLink}
                to={orderPath}
                colorScheme="teal"
                size="lg"
                borderRadius="full"
              >
                {t("hexaco.purchase.cancel.retryPay")}
              </Button>
              <Button
                as={RouterLink}
                to="/hexaco/purchase"
                variant="ghost"
                colorScheme="teal"
                borderRadius="full"
              >
                {t("hexaco.purchase.order.backToPurchase")}
              </Button>
            </VStack>
          </VStack>
        </Container>
      </Box>
    </>
  );
};

export default HexacoOrderCancel;
